import React from 'react'

import { FieldArray } from 'formik'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    adicionaNaoInformar
} from '../../../business-components/Array/Array'

import {
    ValidatorFormPadrao,
} from '../../../business-components/Form/Form'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem1xs6,
    GridItem2xs6,
    GridItem9xs5,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDatePickerPadrao,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    TextValidatorTextRequired,
    TextValidatorTextRequiredDestaque,
    TextValidatorNumber,
    TextValidatorNumberRequired,
    TextValidatorValor,
    TextValidatorValorRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
    TextFieldTextSelectRequired,
    TextFieldNumberSelectRequired,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import familiaresList from '../../../business-rules/List/familiaresList'

import administradoraConsorcioList from '../../../business-rules/List/Consorcio/administradoraConsorcioList'

import tipoConsorcioList from '../../../business-rules/List/Consorcio/tipoConsorcioList'

import pessoaFisicaJuridicaList from '../../../business-rules/List/Consorcio/pessoaFisicaJuridicaList'

import statusGrupoConsorcioList from '../../../business-rules/List/Consorcio/statusGrupoConsorcioList'

import tipoFormaPagtoPremioList from '../../../business-rules/List/tipoFormaPagtoPremioList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    incrementaContConsorcio,
    processaRegistrosDefaultIniciaisConsorcio,
    processaValoresDefaultIniciaisConsorcio,
    calculaTotaisConsorcio,
} from './ConsorcioServiceConsorcio'


const ConsorcioFormConsorcio = ({ values, handleChange, handleSubmit, setFieldValue, vars }) => {

    calculaTotaisConsorcio(values)

    return (
        <ValidatorFormPadrao 
            onSubmit={handleSubmit}
            onError={
                () => null
            }
        >
            <PanelRadioGroup
                name="familiarConsorcio"
                value={Number.parseInt(values.familiarConsorcio) || ''}
                onChange={(e) => {
                    handleChange(e)
                }}
                list={values.totalConsorcio}
                onBlur={
                    processaRegistrosDefaultIniciaisConsorcio(values,
                        Number.parseInt(values.familiarConsorcio))
                }
                helpText={''}
            />

            <FieldArray name="consorcio">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.consorcio?.map((item, ind) => {

                                processaValoresDefaultIniciaisConsorcio(item)
                                
                                return item.familiar === Number.parseInt(values.familiarConsorcio)
                                ? (
                                    <GridItem12
                                        key={ind}
                                    >
                                        <CardGridEntradaDados>
                                            <CardGridDivHeaderEntradaDados>
                                                <GridContainer>
                                                    <GridItem2xs6>
                                                        <TextValidatorTextRequiredDestaque
                                                            name={`consorcio[${ind}].numeroConsorcio`}
                                                            placeholder={LABEL.numeroConsorcio}
                                                            label={LABEL.numeroConsorcio}
                                                            value={item.numeroConsorcio || ''}
                                                            onChange={handleChange}
                                                            tamMax={TAMMAX.numeroConsorcio}
                                                        />
                                                    </GridItem2xs6>
                                                    <GridItem9xs5 />
                                                    <GridItem1>
                                                        <IconButtonClearEntradaDados
                                                            onClick={() => {
                                                                arrayHelpers.remove(ind)
                                                            }}
                                                        />
                                                    </GridItem1>
                                                </GridContainer>
                                            </CardGridDivHeaderEntradaDados>

                                            <CardGridDivBodyEntradaDados>
                                                <GridContainer>
                                                    <GridItem2xs6>
                                                        <TextFieldNumberSelectRequired
                                                            name={`consorcio[${ind}].administradoraConsorcio`}
                                                            label={LABEL.administradoraConsorcio}
                                                            value={item.administradoraConsorcio || ''}
                                                            onChange={handleChange}
                                                            list={administradoraConsorcioList(false)}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextFieldTextSelectRequired
                                                            name={`consorcio[${ind}].tipoConsorcio`}
                                                            label={LABEL.tipoConsorcio}
                                                            value={item.tipoConsorcio || ''}
                                                            onChange={handleChange}
                                                            list={tipoConsorcioList}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorTextRequired
                                                            name={`consorcio[${ind}].grupoConsorcio`}
                                                            label={LABEL.grupoConsorcio}
                                                            value={item.grupoConsorcio || ''}
                                                            onChange={handleChange}
                                                            tamMax={TAMMAX.grupoConsorcio}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorNumberRequired
                                                            name={`consorcio[${ind}].cotaConsorcio`}
                                                            label={LABEL.cotaConsorcio}
                                                            value={item.cotaConsorcio === 0 ? 0 : item.cotaConsorcio || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.cotaConsorcio}
                                                            numMax={NUMMAX.cotaConsorcio}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextFieldTextSelectRequired
                                                            name={`consorcio[${ind}].pessoaFisicaJuridica`}
                                                            label={LABEL.pessoaFisicaJuridica}
                                                            value={item.pessoaFisicaJuridica || ''}
                                                            onChange={handleChange}
                                                            list={pessoaFisicaJuridicaList}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextFieldTextSelect
                                                            name={`consorcio[${ind}].statusGrupoConsorcio`}
                                                            label={LABEL.statusGrupoConsorcio}
                                                            value={item.statusGrupoConsorcio || ''}
                                                            onChange={handleChange}
                                                            list={statusGrupoConsorcioList(false)}
                                                        />
                                                    </GridItem2xs6>

                                                    
                                                </GridContainer>

                                                <GridContainer>
                                                    <GridItem2xs6>
                                                        <MuiPickersUtilsProviderPadrao>
                                                            <KeyboardDatePickerPadrao
                                                                name={`consorcio[${ind}].dataAssembleia`}
                                                                label={LABEL.dataAssembleia}
                                                                value={item.dataAssembleia}
                                                                onChange={(date) => {
                                                                    setFieldValue(
                                                                        `consorcio[${ind}].dataAssembleia`,
                                                                        date,
                                                                    )}
                                                                }
                                                            />
                                                        </MuiPickersUtilsProviderPadrao>
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorNumber
                                                            name={`consorcio[${ind}].numeroAssembleiaParticipacao`}
                                                            label={LABEL.numeroAssembleiaParticipacao}
                                                            value={item.numeroAssembleiaParticipacao === 0 ? 0 : item.numeroAssembleiaParticipacao || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.numeroAssembleiaParticipacao}
                                                            numMax={NUMMAX.numeroAssembleiaParticipacao}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorValorRequired
                                                            name={`consorcio[${ind}].valorCreditoConsorcio`}
                                                            label={LABEL.valorCreditoConsorcio}
                                                            value={item.valorCreditoConsorcio === 0 ? 0 : item.valorCreditoConsorcio || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorValor
                                                            name={`consorcio[${ind}].valorParcelaInicial`}
                                                            label={LABEL.valorParcelaInicial}
                                                            value={item.valorParcelaInicial === 0 ? 0 : item.valorParcelaInicial || ''}
                                                            onChange={handleChange}
                                                        />
                                                    </GridItem2xs6>
                                                    
                                                    <GridItem2xs6>
                                                        <TextFieldTextSelect
                                                            name={`consorcio[${ind}].tipoFormaPagtoConsorcio`}
                                                            label={LABEL.tipoFormaPagto}
                                                            value={item.tipoFormaPagtoConsorcio || ''}
                                                            onChange={handleChange}
                                                            list={tipoFormaPagtoPremioList}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <MuiPickersUtilsProviderPadrao>
                                                            <KeyboardDatePickerPadrao
                                                                name={`consorcio[${ind}].dataVenctoBoleto`}
                                                                label={LABEL.dataVenctoBoleto}
                                                                value={item.dataVenctoBoleto}
                                                                onChange={(date) => {
                                                                    setFieldValue(
                                                                        `consorcio[${ind}].dataVenctoBoleto`,
                                                                        date,
                                                                    )}
                                                                }
                                                            />
                                                        </MuiPickersUtilsProviderPadrao>
                                                    </GridItem2xs6>
                                                </GridContainer>
                                                
                                                <GridContainer>
                                                    <GridItem2xs6>
                                                        <TextValidatorNumberRequired
                                                            name={`consorcio[${ind}].prazoTotalGrupoConsorcio`}
                                                            label={LABEL.prazoTotalGrupoConsorcio}
                                                            value={item.prazoTotalGrupoConsorcio === 0 ? 0 : item.prazoTotalGrupoConsorcio || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.prazoTotalGrupoConsorcio}
                                                            numMax={NUMMAX.prazoTotalGrupoConsorcio}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorNumber
                                                            name={`consorcio[${ind}].prazoTotalCotaConsorcio`}
                                                            label={LABEL.prazoTotalCotaConsorcio}
                                                            value={item.prazoTotalCotaConsorcio === 0 ? 0 : item.prazoTotalCotaConsorcio || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.prazoTotalCotaConsorcio}
                                                            numMax={NUMMAX.prazoTotalCotaConsorcio}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorNumberRequired
                                                            name={`consorcio[${ind}].numeroTotalParticipantesGrupoConsorcio`}
                                                            label={LABEL.numeroTotalParticipantesGrupoConsorcio}
                                                            value={item.numeroTotalParticipantesGrupoConsorcio === 0 ? 0 : item.numeroTotalParticipantesGrupoConsorcio || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.numeroTotalParticipantesGrupoConsorcio}
                                                            numMax={NUMMAX.numeroTotalParticipantesGrupoConsorcio}
                                                        />
                                                    </GridItem2xs6>
                                                    
                                                    <GridItem2xs6>
                                                        <TextValidatorNumberRequired
                                                            name={`consorcio[${ind}].taxaAdministracaoTotal`}
                                                            label={LABEL.taxaAdministracaoTotal}
                                                            value={item.taxaAdministracaoTotal === 0 ? 0 : item.taxaAdministracaoTotal || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.perc}
                                                            numMax={NUMMAX.perc}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorNumberRequired
                                                            name={`consorcio[${ind}].percFundoReserva`}
                                                            label={LABEL.percFundoReserva}
                                                            value={item.percFundoReserva === 0 ? 0 : item.percFundoReserva || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.perc}
                                                            numMax={NUMMAX.perc}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem2xs6>
                                                        <TextValidatorNumberRequired
                                                            name={`consorcio[${ind}].percSeguroPrestamista`}
                                                            label={LABEL.percSeguroPrestamista}
                                                            value={item.percSeguroPrestamista === 0 ? 0 : item.percSeguroPrestamista || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.perc}
                                                            numMax={NUMMAX.perc}
                                                        />
                                                    </GridItem2xs6>

                                                    <GridItem1xs6>
                                                        <TextValidatorNumber
                                                            name={`consorcio[${ind}].percLanceEmbutido`}
                                                            label={LABEL.percLanceEmbutido}
                                                            value={item.percLanceEmbutido === 0 ? 0 : item.percLanceEmbutido || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.perc}
                                                            numMax={NUMMAX.perc}
                                                        />
                                                    </GridItem1xs6>

                                                    <GridItem1xs6>
                                                        <TextValidatorNumber
                                                            name={`consorcio[${ind}].percLanceFixo`}
                                                            label={LABEL.percLanceFixo}
                                                            value={item.percLanceFixo === 0 ? 0 : item.percLanceFixo || ''}
                                                            onChange={handleChange}
                                                            numMin={NUMMIN.perc}
                                                            numMax={NUMMAX.perc}
                                                        />
                                                    </GridItem1xs6>

                                                    <GridItem2xs6>
                                                        <TextFieldTextSelect
                                                            name={`consorcio[${ind}].idCorretorConsorcios`}
                                                            label={LABEL.idCorretorConsorcios}
                                                            value={item.idCorretorConsorcios || ''}
                                                            onChange={handleChange}
                                                            list={adicionaNaoInformar(vars.equipeList)}
                                                        />
                                                    </GridItem2xs6>
                                                </GridContainer>
                                            </CardGridDivBodyEntradaDados>
                                        </CardGridEntradaDados>
                                    </GridItem12>
                                )
                                :
                                (
                                    ''
                                )
                            })}
                        </GridContainer>

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirConsorcio} 
                            disabled={familiaresList(values).length === 0 || !values.familiarConsorcio ? true : false}
                            onClick={() =>
                                {
                                    incrementaContConsorcio(values)
                                    arrayHelpers.push({
                                        id: values.contConsorcio,
                                        familiar: Number.parseInt(values.familiarConsorcio),
                                    })
                                }
                            }
                        />
                    </DivForm>
                )}
            </FieldArray>
        </ValidatorFormPadrao>
    )
}

export default ConsorcioFormConsorcio